import React, { Component } from "react";
import {
    Message,
    Button,
    Popconfirm,
    Modal,
    Row,
    Col,
    Tag,
    Select,
    FormControl,
    Label,
} from "tinper-bee";
import Layout from "../../pages/Layout";
import * as util from "../../../src/utils/index";
import SubmitModal from "./SubmitModal";
import "./index.less";
interface iState {
    name: string;
    version: string;
    env: string;
    showModal: boolean;
    tneItem: any;
    type: string;
    userList: any;
}
class TNE2nd extends Component<any, iState> {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            version: "",
            env: "daily",
            type: "iuap",
            showModal: false,
            tneItem: {},
            userList: []
        };
    }

    async componentDidMount(){
        let data = await util.get('/npm/getTne2ndUserList');
        this.setState({
            userList: Array.isArray(data.data) ? data.data : []
        })
    }

    onChange = (key: string) => (value: string) => {
        let newStr = value.replace(/\s+/g, "");
        this.setState((prevState) => ({
            ...prevState,
            [key]: newStr,
        }));
    };

    onConfirm = async () => {
        let res = await this.manualTne2ndsingleDeploy();
        if(res?.success){
            this.setState({
                showModal: false,
                tneItem: {},
                name: "",
                version: "",
            });
            Message.create({ content: "更新成功", color: "success" });
        }else{
            return Message.create({ content: res?.message || '更新失败', color: "danger" });
        }
    };

    checkUserAuth = () => {
        let { userList, name } = this.state;
        let localuser = localStorage.getItem('user')
        let userid = localuser ? JSON.parse(localuser).userId : null;
        let user = userList.find(item => item.userid === userid);
        if(!user){
            return false;
        }
        let {is_admin, pkg_list} = user;
        if(is_admin === 1){
            return true;
        }else{
            let list = pkg_list.split(',');
            return list.includes(name);
        }
    }

    // 更新manifest.json
    manualTne2ndsingleDeploy = async () => {
        let { name, env, version } = this.state;
        return util.post("/npm/manualTne2ndsingleDeploy", {
            name,
            env,
            version
        });
    };

    // 校验
    checkSingleTne2nd = async () => {
        let { name, env } = this.state;
        return util.post("/npm/checkSingleTne2nd", {
            name,
            env,
        });
    };

    // 入库
    manualUpdateTne2ndVersion = async () => {
        let { name, version, env } = this.state;
        return util.post("/npm/manualUpdateTne2ndVersion", {
            env,
            version,
            name,
        });
    };

    submit = async () => {
        let res: any =  this.checkUserAuth();
        console.log(res);
        if (!res) {
            return Message.create({ content: "您没有更新权限", color: "danger" });
        }
        let res1: any = await this.manualUpdateTne2ndVersion();
        if (res1?.success) {
            let res2: any = await this.checkSingleTne2nd();
            let { result, success, message } = res2;
            if (!success) {
                Message.create({ content: message, color: "danger" });
            } else {
                if(result && result.length){
                    if(result[0].type === 'same'){
                        return Message.create({ content: "当前运行时版本与当前修改版本一致，无需提交修改", color: "danger" });
                    }
                    this.setState({
                        showModal: true,
                        tneItem: result[0]
                    });
                }else{
                    return Message.create({ content: "入库失败，联系刘石磊", color: "success" });
                }

            }
        } else {
            return Message.create({ content: res1.message, color: "danger" });
        }
    };

    handleModal = (value) => async () => {
        if (value === true) {
            let { name, version } = this.state;
            if (!name || !version) {
                Message.create({
                    content: "包名和版本不能为空",
                    color: "warning",
                });
                return;
            }
        }else{
            this.setState({
                tneItem: {},
            });
        }
        this.setState({
            showModal: value,
        });
    };
    render() {
        let { env, name, version, type } = this.state;
        return (
            <div className="tne2nd">
                <h1>TNE服务化二方包申请变更单</h1>
                <div className="list-item">
                    <Label>服务化二方包类型：</Label>
                    <Select
                        value={type}
                        className="list"
                        onChange={this.onChange("type")}
                        style={{width: 300}}
                    >
                        <Select.Option value="iuap">平台</Select.Option>
                        <Select.Option value="yonbip">领域</Select.Option>
                    </Select>
                </div>
                <div className="list-item">
                    <Label>服务化二方包包名：</Label>
                    <FormControl
                        value={name}
                        onChange={this.onChange("name")}
                        className="list"
                        placeholder="请输入包名"
                    />
                </div>
                <div className="list-item">
                    <Label>服务化二方包版本：</Label>
                    <FormControl
                        onChange={this.onChange("version")}
                        value={version}
                        className="list"
                        placeholder="请输入版本"
                    />
                </div>
                <div className="list-item">
                    <Label>更新环境：</Label>
                    <Select
                        value={env}
                        className="list"
                        style={{width: 300}}
                        onChange={this.onChange("env")}
                    >
                        <Select.Option value="daily">日常环境</Select.Option>
                        <Select.Option value="pre">预发环境</Select.Option>
                        <Select.Option value="daily-dedicated">日常多数据库环境</Select.Option>
                    </Select>
                </div>
                <div className="list-item">
                    <Button onClick={this.submit} colors="primary">
                        提交
                    </Button>
                </div>
                <SubmitModal
                    env={env}
                    tneItem={this.state.tneItem}
                    show={this.state.showModal}
                    onConfirm={this.onConfirm}
                    onCancel={this.handleModal(false)}
                />
            </div>
        );
    }
}


export default Layout(TNE2nd, 'tne2nd-page')
